import {
  MenuItemWithIcon,
  ModalOpenProcess,
  ModalOpenProcessRef,
} from "@msys/ui";
import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Button } from "@mui/material";
import * as Sentry from "@sentry/react";
import { useTranslate } from "@tolgee/react";
import { useSnackbar } from "notistack";
import React from "react";
import { assertNever } from "../../../../utils.js";
import { ShowTemplateVariantProtocolModal } from "../ShowTemplateVariantProtocolModal.js";
import { useFetchUpdateProtocolEntries } from "../useTemplateVariantUpdateProtocol.js";

export function ShowTemplateVariantProtocolButton({
  templateId,
  versionNumber,
  pathToDocList,
  type,
}: {
  templateId: string;
  versionNumber: number;
  pathToDocList: string;
  type: "button" | "menu-item";
}) {
  const { t } = useTranslate(["Templates"]);
  const { enqueueSnackbar } = useSnackbar();

  const { fetchProtocolEntries, loadingProtocolEntries } =
    useFetchUpdateProtocolEntries();
  const processRef = React.useRef<ModalOpenProcessRef>();

  const handleClick = async () => {
    try {
      const entries = await fetchProtocolEntries({
        docId: templateId,
        toVersionNumber: versionNumber,
      });
      // const currentEntries = entries.filter(
      //   e => e.toVersionNumber === versionNumber
      // );
      processRef.current?.open({ entries });
    } catch (e) {
      if (e instanceof Error) enqueueSnackbar(e.message, { variant: "error" });
      Sentry.captureException(e);
    }
  };

  return (
    <>
      {type === "button" ? (
        <Button
          loading={loadingProtocolEntries}
          variant={"outlined"}
          onClick={async e => {
            e.preventDefault();
            e.stopPropagation();
            await handleClick();
          }}
        >
          {t("Show update protocol", { ns: "Templates" })}
        </Button>
      ) : type === "menu-item" ? (
        <MenuItemWithIcon
          icon={<OutlinedFlagIcon />}
          onClick={async e => {
            await handleClick();
          }}
        >
          {t("Show update protocol", { ns: "Templates" })}
        </MenuItemWithIcon>
      ) : (
        assertNever(type)
      )}
      <ModalOpenProcess
        ref={processRef}
        Modal={ShowTemplateVariantProtocolModal}
        modalProps={{
          pathToDocList,
          toVersionNumber: versionNumber,
          entries: [],
        }}
      />
    </>
  );
}
